const getJobFiltersList = (jobFilters, filters) => {
  const selectedCountry = filters.c[0]
  const selectedState = filters.s[0]
  const selectedLocation = filters.l[0]
  
  const allLocations = []

  const filterSort = (prev, next) => prev.value?.localeCompare(next.value)

  jobFilters?.filters?.forEach((country) => {
    country?.states?.forEach((state) => {
      state?.locations?.forEach((location) => {
        // we then only filter on what is selected
        if (selectedCountry && selectedCountry !== country.name) return
        if (selectedState && selectedState !== state.name) return
        if (selectedLocation && selectedLocation !== location.name) return
        const locationInfos = {
          location: location.name,
          state: state.name,
          country: country.name,
        }
        allLocations.push(locationInfos)
      })
    })
  })

  const availableFilters = allLocations?.reduce(
    (acc, current) => {
      !acc.countries.find(
        (countryObj) => countryObj.value === current.country
      ) &&
      acc.countries.push({value: current.country, label: current.country})

      !acc.states.find((stateObj) => stateObj.value === current.state) &&
      acc.states.push({value: current.state, label: current.state})

      !acc.locations.find(
        (locationObj) => locationObj.value === current.location
      ) &&
      acc.locations.push({value: current.location, label: current.location})
      return acc
    },
    {
      countries: [],
      states: [],
      locations: [],
    }
  )

  const availableCategories = jobFilters?.categories?.map((category) => ({
    label: category,
    value: category,
  }))

  return [
    {
      type: 'checkbox',
      title: 'Only Show New Jobs',
      value: 'nj',
    },
    {
      type: 'checkbox',
      title: 'Only Show Internships',
      value: 'i',
    },
    {
      type: 'checkbox',
      title: 'Only Show Remote Positions',
      value: 'rp',
    },
    {
      type: 'select',
      title: 'country',
      description: 'Country: Select',
      options: availableFilters?.countries?.sort(filterSort),
      value: 'c',
    },
    {
      type: 'select',
      title: 'state',
      description: 'State / Region: Select',
      options: availableFilters?.states?.sort(filterSort),
      value: 's',
    },
    {
      type: 'select',
      title: 'location',
      description: 'Location: Select',
      options: availableFilters?.locations?.sort(filterSort),
      value: 'l',
    },
    {
      type: 'select',
      title: 'category',
      description: 'Job Category: Select',
      options: availableCategories?.sort(filterSort),
      value: 'cat',
    },
  ]
}

export default getJobFiltersList
